import { useSession } from './useSession';

export const useIsWalletConnected = () => {
  const { state: sessionState } = useSession();
  const isWalletConnected = sessionState.context.wallet;

  return isWalletConnected;
};
